import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { AccountManager } from 'src/app/modules/shared/entities/account-manager.class';
import { StorageValues } from 'src/app/modules/shared/entities/storage-values.enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FollowUpTab } from 'src/app/modules/shared/entities/follow-up-tab.enum';
import { DashboardService } from '../../services/dashboard.service';
import { LeadsSearchComponent } from '../leads-table/leads-search/leads-search.component';
import { ProjectsSearchComponent } from '../projects-table/projects-search/projects-search.component';

@Component({
  selector: 'app-follow-up-search',
  templateUrl: './follow-up-search.component.html',
  styleUrls: ['./follow-up-search.component.scss'],
  standalone: false
})
export class FollowUpSearchComponent implements OnInit, OnChanges {
  @Input() accountManagerEmployeeId: string;
  @Input() activeTab: number;
  @Output() searchEvent: EventEmitter<any> = new EventEmitter();

  appStrings: AppLocalization;
  amEmployeeId: string;
  isAccountManager = false;
  accountManagerId: string;

  cachedSearchValues: any;
  searchValue: string;
  disableClearAll = true;

  storageKey: string;
  searchComponent: any;
  isHistory: boolean;

  constructor(
    private appInfoService: AppInfoService,
    private dashboardService: DashboardService,
    private dialog: MatDialog,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.amEmployeeId = this.appInfoService.userData.UserInfo.EmployeeId;

    switch (this.activeTab) {
      case FollowUpTab.Leads:
        this.storageKey = StorageValues.LeadsKey;
        this.searchComponent = LeadsSearchComponent;
        this.isHistory = false;
        break;
      case FollowUpTab.LeadsHistory:
        this.storageKey = StorageValues.LeadsHistoryKey;
        this.searchComponent = LeadsSearchComponent;
        this.isHistory = true;
        break;
      case FollowUpTab.Projects:
        this.storageKey = StorageValues.ProjectsKey;
        this.searchComponent = ProjectsSearchComponent;
        this.isHistory = false;
        break;
      case FollowUpTab.ProjectsHistory:
        this.storageKey = StorageValues.ProjectsHistoryKey;
        this.searchComponent = ProjectsSearchComponent;
        this.isHistory = true;
    }

    this.cachedSearchValues =
      JSON.parse(sessionStorage.getItem(StorageValues.CachedFilters + this.storageKey));
    this.searchValue = this.cachedSearchValues?.displayedSearchValue ?? this.appStrings.accounts_search;
    this.disableClearAll = !this.cachedSearchValues?.displayedSearchValue;
    this.isAccountManager = this.appInfoService.isAccountManager();
    this.dashboardService.getAccountManagers((list: AccountManager[]) => {
      list.forEach((item: AccountManager) => {
        if (item.employeeId === this.amEmployeeId || item.employeeId === this.accountManagerEmployeeId) {
          this.accountManagerId = item.id;
        }
      });
    });
  }

  ngOnChanges() {
    if (!this.isAccountManager && this.accountManagerEmployeeId !== undefined) {
      this.dashboardService.getAccountManagers((list: AccountManager[]) => {
        list.forEach((item: AccountManager) => {
          if (item.employeeId === this.accountManagerEmployeeId) {
            this.accountManagerId = item.id;
          }
        });
      });

      this.cachedSearchValues =
        JSON.parse(sessionStorage.getItem(StorageValues.CachedFilters + this.storageKey));
      this.searchValue = this.cachedSearchValues?.displayedSearchValue ?? this.appInfoService.appStrings.accounts_search;
      this.disableClearAll = !this.cachedSearchValues?.displayedSearchValue;
      this.searchEvent.emit();
    }
  }

  handleClearAll() {
    sessionStorage.removeItem(StorageValues.CachedFilters + this.storageKey);
    this.searchValue = this.appStrings.accounts_search;
    this.searchEvent.emit();
    this.disableClearAll = true;
  }

  openSearch() {
    const dialog = this.dialog.open(this.searchComponent, {
      panelClass: ['ds', 'fullWidth', this.deviceService.isMobile() ? 'fullScreen' : ''],
      data: { isHistory: this.isHistory, accountManagerId: this.accountManagerId },
      autoFocus: false
    });

    dialog.afterClosed().subscribe((result) => {
      if (result?.performSearch) {
        this.searchEvent.emit();
        this.searchValue = result?.searchDisplay;
        this.disableClearAll = result?.searchDisplay === this.appStrings.accounts_search;
      }
    });
  }
}
